/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const systemSuccessMsg = 'System successfully saved the information.';
export const errorMessageAtleast = 'Atleast one Email Type must be selected.';
export const codeDomainList = ['EMAIL_TYPE_CD'];
